"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonizationIncentives = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
class ColonizationIncentives {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.COLONIZATION_INCENTIVES;
        this.description = 'Gain 2 M€ for each colony (max 5). Gain 3 energy for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.EMPOWER;
        this.currentDelegate = PartyName_1.PartyName.POPULISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const coloniesCount = Math.min(player.getColoniesCount(), 5);
            if (coloniesCount > 0)
                player.addResource(Resources_1.Resources.MEGACREDITS, coloniesCount * 2, { log: true });
            const influence = turmoil.getPlayerInfluence(player);
            if (influence > 0)
                player.addResource(Resources_1.Resources.ENERGY, influence * 3, { log: true });
        });
    }
}
exports.ColonizationIncentives = ColonizationIncentives;
//# sourceMappingURL=ColonizationIncentives.js.map